import { Text } from "@chakra-ui/react";
import { ListaRelatorioPrestacaoContasResponse } from "features/relatorios/prestacao-contas/typings";
import { useMemo } from "react";
import moment from "moment";

function useRelatorioPrestacaoContasColumns() {
  return useMemo(() => {
    return [
      {
        title: "Nome do relatório",
        render: (original: ListaRelatorioPrestacaoContasResponse) => (
          <Text>{original.nome}</Text>
        ),
      },
      {
        title: "Observação",
        render: (original: ListaRelatorioPrestacaoContasResponse) => (
          <Text>{original.observacao}</Text>
        ),
      },
      {
        title: "Período",
        width: 220,
        render: (original: ListaRelatorioPrestacaoContasResponse) => {
          if (!original.dataInicio) {
            return <Text>Sempre</Text>;
          }
          if (moment(original.dataInicio).isSame(original.dataFim, "month")) {
            return (
              <Text>
                Apenas {moment(original.dataInicio).format("MMM/YYYY")}
              </Text>
            );
          }
          return (
            <Text>
              De {moment(original.dataInicio).format("MMM/YYYY")} até{" "}
              {moment(original.dataFim).format("MMM/YYYY")}
            </Text>
          );
        },
      },
    ];
  }, []);
}

export default useRelatorioPrestacaoContasColumns;
